import { Box } from "@mui/material";
import type { ReactNode } from "react";

interface ConditionTreeRowProps {
  children: ReactNode;
  isFirst: boolean;
  isLast: boolean;
  shouldRenderConnector: boolean;
}

const CONNECTOR_GAP_OFFSET = "4px";

const getBranchConnectorStyles = (isFirst: boolean, isLast: boolean) => {
  return {
    position: "relative",
    minWidth: "13px",
    "&::before": {
      content: '""',
      position: "absolute",
      left: 0,
      top: isFirst ? "50%" : `-${CONNECTOR_GAP_OFFSET}`,
      bottom: isLast ? "50%" : `-${CONNECTOR_GAP_OFFSET}`,
      borderLeft: (theme: { palette: { divider: string } }) => `1px dashed ${theme.palette.divider}`,
    },
    "&::after": {
      content: '""',
      position: "absolute",
      left: "2px",
      top: "50%",
      width: "100%",
      borderTop: (theme: { palette: { divider: string } }) => `1px dashed ${theme.palette.divider}`,
    },
  };
};

const ConditionTreeRow = ({ children, isFirst, isLast, shouldRenderConnector }: ConditionTreeRowProps) => {
  return (
    <Box sx={{ display: "flex", gap: 0.5, width: "100%", alignItems: "stretch" }}>
      {shouldRenderConnector && <Box sx={getBranchConnectorStyles(isFirst, isLast)} />}
      <Box sx={{ flex: 1, minWidth: 0 }}>{children}</Box>
    </Box>
  );
};

export default ConditionTreeRow;
